<div class="white-background">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div class="tagline">
            <h5 class="text-weight-bold " style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background">
        <mat-card class="shadow-lg card-form">
            <mat-card-content class="rounded-lg text-center">
                <h3 class="my-4" style="font-weight: bold">Returning Member</h3>
                <form [formGroup]="form">
                    <div class="account-create return-member">
                        <div class="formHeading">

                            <div class="row mt-5">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">
                                        <mat-label>Username</mat-label>
                                        <mat-icon matPrefix>person</mat-icon>
                                        <input
                                                id="email-input"
                                                type="email"
                                                matInput
                                                formControlName="email"
                                        >

                                        <mat-error *ngIf="form.controls['email'].errors && submitted" class="invalid-feedback">Email is required</mat-error>

                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12">
                                    <mat-form-field appearance="outline" class="w-100">

                                        <mat-label>Password</mat-label>
                                        <mat-icon matPrefix>key</mat-icon>
                                        <mat-icon matSuffix (click)="typePassword = !typePassword">{{ typePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                                        <input
                                                id="password-input"
                                                [type]="typePassword ? 'password' : 'text'"
                                                matInput
                                                formControlName="password"
                                        >

                                        <mat-error *ngIf="form.controls['password'].errors && submitted && form.controls['password'].errors['required']">Password is required</mat-error>
                                        <mat-error *ngIf="form.controls['password'].errors && submitted && form.controls['password'].errors['minlength']">Password must be at least 8 characters</mat-error>

                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="form-group mt-3">
                                <div class="d-flex justify-content-center mt-2">
                                    <button style="margin-right: 10px;"
                                            (click)="onSubmit()"
                                            mat-raised-button
                                            class="mt-2 form-button">
                                        <mat-icon>login</mat-icon>Open My Wallet
                                    </button>
                                    <button
                                            mat-raised-button
                                            class="mt-2 form-button"
                                            type="button"
                                            (click)="goHome()">
                                        <mat-icon>chevron_right</mat-icon>Cancel
                                    </button>
                                </div>
                                <div class="mt-5">
                                    <div class="">
                                        <a [routerLink]="['/forgot-password']"><span>Forgot password?</span></a>
                                    </div>
                                    <div class="mt-2 mb-3">
                                        <span>Don't have an account?<a [routerLink]="['/register']">&nbsp;Sign up now!</a></span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>


